import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

import { ToastType } from 'src/shared/components/Toast/types';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { useToaster } from 'src/shared/providers/Toaster';

import { Component as Warning } from 'assets/icons/ui/warning.svg';

interface OfflineButtonHandlerProps extends BoxProps {
  isOnline: boolean;
}

const ErrorToastColor = 'danger400' as const;

const OfflineButtonWrapper = ({
  isOnline,
  children,
}: OfflineButtonHandlerProps) => {
  const { addToast, removeToast } = useToaster();
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  const toast = {
    title: t('app.noInternetConnection'),
    subtitle: t('app.checkConnection'),
    type: ToastType.ACTIVE,
    icon: Warning,
    onPress: removeToast,
    backgroundColor: ErrorToastColor,
  };

  return (
    <Box
      onClick={isOnline ? undefined : () => addToast(toast)}
      testId="offlineButtonWrapper"
    >
      {children}
    </Box>
  );
};

export { OfflineButtonWrapper };
